/**
 *
 *
 */

/* 배송상태 */
export const SETTLEMENT_STATUS = {
  WAIT: {
    value: 'WAIT',
    title: '정산완료',
    color: 'default',
  },
  DECIDED: {
    value: 'DECIDED',
    title: '출금완료',
    color: 'green',
  },
  UNDECIDED: {
    value: 'UNDECIDED',
    title: '출금대기',
    color: 'purple',
  },
};
